























































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { menuList, pathList, bgList } from "./headList";
import reagister from "./reagister.vue";
import { getDoc } from "@/req/homes";
@Component({
  components: { reagister },
})
export default class Home extends Vue {
  public limit = 1;
  public routeBackground = "#242424";
  public menuList = menuList;
  public downShow = false;
  public processShow = false;
  public forumShow = false;
  public forumSelectedId = '';
  public forumList = [
    {
      id: 1,
      forumTitle: "传奇论坛",
      content: "",
      forumIcon: require("@/assets/img/indexNew/chuanqi-forum.png")
    },
    {
      id: 2,
      forumTitle: "传世论坛",
      forumIcon: require("@/assets/img/indexNew/chuanshi-forum.png")
    },
    {
      id: 3,
      forumTitle: "传奇3论坛",
      forumIcon: require("@/assets/img/indexNew/chuan3-forum.png")
    },
    {
      id: 4,
      forumTitle: "纯PC传奇论坛",
      forumIcon: require("@/assets/img/indexNew/chunpc-forum.png")
    },
  ]; // 交流论坛
  public docList = []; // 一级技术文档
  public secDocList = []; // 二级技术文档
  public selectedId = ''; // 当前选中一级
  public selectedIds = ''; // 当前二级
  public mounted() {
    window.addEventListener("scroll", this.scrollTopBg);
    const bgShow = bgList.some((item) => {
      return this.$route.path == item.path;
    });
    bgShow
      ? (this.routeBackground = "#242424")
      : (this.routeBackground = "none");
    const arr = pathList.filter((items) => {
      return this.$route.path == items.path;
    });
    arr[0].id == 10 ? (this.limit = 1) : (this.limit = arr[0].id);
    this.initDocList()
  }
  public mouseenter(row) {
    if (row.id == 3 && this.$route.name != "engineDownload")
      this.downShow = true;
    if (row.id == 12) {
      this.processShow = true;
    }
    if (row.id == 7) {
      this.forumShow = true;
    }
  }
  public mouseleave(row) {
    this.downShow = false;
    this.processShow = false;
    this.forumShow = false;
  }
  public scrollTopBg() {
    const bgShow = bgList.some((item) => {
      return this.$route.path == item.path;
    });
    const bodyTop = document.documentElement.scrollTop;
    if (bodyTop > 50) {
      this.routeBackground = "#242424";
    } else {
      bgShow
        ? (this.routeBackground = "#242424")
        : (this.routeBackground = "none");
    }
  }
  public destroyed() {
    window.removeEventListener("scroll", this.scrollTopBg);
  }
  @Watch("$route", {immediate: true})
  public routeChange() {
    const bgShow = bgList.some((item) => {
      return this.$route.path == item.path;
    });
    bgShow
      ? (this.routeBackground = "#242424")
      : (this.routeBackground = "none");
    const arr = pathList.filter((items) => {
      return this.$route.path == items.path;
    });
    arr[0].id == 10 ? (this.limit = 1) : (this.limit = arr[0].id);
    if (this.$route.path == "/certificateInquiry") {
      this.menuList = menuList.filter((itm) => {
        return itm.id == 1 || itm.id == 17;
      });
    // } else if (this.$route.path == "/authorization") {
    //   this.menuList = menuList.filter((itm) => {
    //     return itm.id == 18;
    //   });
    } else {
      this.menuList = menuList.filter((itm) => {
        return itm.id !== 17;
      });
    }
  }
  /**
   * 一级标题
   */
  public clickFirst(id) {
    this.selectedIds = '';
    const index = this.docList.findIndex((item: any) => item.id == id)
    if (index !== -1) {
      this.secDocList = (this as any).docList[index].children
    }
    this.selectedId = id
  }
  /**
   * 二级标题
   */
  public clickSecond(id) {
    const index = this.secDocList.findIndex((item: any) => item.id == id)
    if (index !== -1) {
      const url = (this as any).secDocList[index].content;
      window.open(url)
    }
  }
  /**
   * 二级标题
   */
  public clickSeconds(id) {
    this.selectedIds = id
  }
  /**
   * getDoc
   * 获取技术文档
   */
  public async initDocList() {
    const res = await getDoc({
      token: this.$fn.cookies.getToken()
    })
    if (res.code === 200) {
      this.docList = res.data.filter(item => {
        return item.id !== 32
      });
    }
  }
  public clickForum(id) {
    this.forumSelectedId = id
    if (id == 1) {
      this.limit = this.limit;
      window.open("https://bbs.996m2.com/", "_blank");
      return false;
    }
    if (id == 2) {
      this.limit = this.limit;
      window.open("http://woool.996m2.com/", "_blank");
      return false;
    }
    if (id == 3) {
      this.limit = this.limit;
      window.open("https://mir3.996m2.com/", "_blank");
      return false;
    }
    if (id == 4) {
      this.limit = this.limit;
      window.open("https://pc.996m2.com/", "_blank");
      return false;
    }
  }
  public toRoute(item) {
    if (item.id == 5) {
      this.limit = this.limit;
      window.open("https://www.996box.com/", "_blank");
      return false;
    }
    // if (item.id == 6) {
    //   this.limit = this.limit;
    //   window.open("https://bbs.996m2.com/", "_blank");
    //   return false;
    // }
    if (item.id == 7) {
      // this.limit = this.limit;
      // window.open("http://woool.996m2.com/", "_blank");
      return false;
    }
    if (item.id == 11) {
      window.open(item.path, "_blank");
      return false;
    }
    if (item.id == 13) {
      window.open("https://996-tools.dhsf.xqhuyu.com/tutorials/", "_blank");
      return false;
    }
    if (item.id == 17) {
      window.open(item.path, "_blank");
      return false;
    }
    this.limit = item.id;
    this.$router.push(item.path);
  }
  //   public registerBtn() {
  //     const $register = (this as any).$refs.register;
  //     $register.show();
  //   }
}
